import React from "react";

export const aspectoDeLaLiteraturaPublishedAt = (
  <span className="white">
    <i>Revista de las Indias</i>, Bogotá Vol. 8, No. 26 (Feb. 1941)
  </span>
);
